<template>
  <div style="padding: 0 10px">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane v-for="item in comList" :key="item.value" :label="item.title" :name="item.title">
        <div style="border: 1px solid #E4E7ED;border-top: none; padding: 10px;border-radius: 0 0 6px 6px">
          <com :inboundType="item.value" v-if="activeName == item.title"></com>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import com from './com'
export default {
  name: "InternationalInvoice", // 国际发货单列表
  components:{
    com
  },
  data() {
    return {
      activeName: '采购入库',
    //   comList: [{title:'采购入库',value:0},{title:'手动入库',value:1},{title:'调拨入库',value:2}]
      comList: [{title:'采购入库',value:0},{title:'手动入库',value:1}]
    }
  },
}
</script>

<style scoped>
::v-deep .el-tabs__header {
  margin-bottom: 0px !important;
}
</style>